<template>
  <div>
    <v-container fluid class="card-flex-toolbar noPadding" scrollable style="width:100%;">
      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Transactions</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip left>
          <v-btn v-on:click.prevent="$router.push({ path: '/dashboard/addtransaction' })"
                 slot="activator"
                 small
                 fab
                 flat
                 middle
                 right>
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <span>Add Transaction</span>
        </v-tooltip>

        <!--Speed Dial-->
        <v-speed-dial v-model="speedDial"
                      :direction="direction"
                      :transition="transition">
          <v-btn slot="activator"
                 v-model="speedDial"
                 flat
                 small
                 fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
            <v-icon>fas fa-times</v-icon>
          </v-btn>

          <!-- Search Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewSearch = !viewSearch"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-search</v-icon>
            </v-btn>
            <span>Search</span>
          </v-tooltip>
          <!--End Of Search Button-->
          <!-- Filter Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewFilter = !viewFilter"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-filter</v-icon>
            </v-btn>
            <span>Filter</span>
          </v-tooltip>
          <!-- End Of Filter Button -->

        </v-speed-dial>
        <!--End Of Speed Dial-->

      </v-toolbar>

      <!--Card Design-->

      <v-container fluid style="min-height: 0; " v-bind:class="{'padContent': !drawer}" grid-list-lg>
        <v-layout row wrap>

          <!--Search Box-->
          <template v-if="viewSearch && !viewFilter">
            <v-flex xs12>
              <v-text-field label="Search"
                            v-model="search"
                            append-icon="fas fa-search"
                            @change="getSearchItems"
                            @input="getSearchItems"></v-text-field>
            </v-flex>
          </template>
          <!--End Of Search Box-->

          <!--Filter Box-->
          <template v-if="viewFilter">
            <MyFilter v-bind:filterBy="filterBy" v-on:filterData="getfilteredData($event)"></MyFilter>
          </template>
          <!--End Of Filter Box-->

          <!--No Data Notice-->
          <template v-if="itemsMinusDeleted.length === 0">
            <v-flex xs12>
              <v-card>
                <v-card-text class="text-xs-center">
                  <v-flex xs12>Sorry, There is currently no data to display here</v-flex>
                  <span><v-icon x-large>fas fa-frown</v-icon></span>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>
          <!--End Of No Data Notice-->

          <ListItem v-for="itemMinus in itemsMinusDeleted" v-bind:liItem="{type: 'transaction',data: itemMinus}" :key="itemMinus.id" ref="listItem" v-on:Edit="redirectToEditPage($event)" v-on:Delete="DeleteTransaction($event)"></ListItem>

          <!--<template v-for="(item, i) in itemsMinusDeleted" item-key="id">
            <v-flex xs12 md6 xl4>
              <v-card :class="{'itemCarddark':$store.state.NightMode.itemCard == 'itemCarddark','itemCardlight':$store.state.NightMode.itemCard == 'itemCardlight'}">
                <v-card-text>
                  <div class="headline">{{item.transactionName}}</div>
                  <v-divider></v-divider>
                </v-card-text>
                <v-card-actions>
                  <v-toolbar flat style="width:170px;margin-left: auto;margin-right: auto;border-radius: 28px;">
                    <v-btn icon class="mx-0" v-on:click.prevent="redirectToEditPage(item.id)" style="margin-left: 15px !important;">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon class="mx-0" v-on:click.prevent="DeleteTransaction(item)" style="margin-right: 15px !important;">
                      <v-icon color="error">delete</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="item.show = !item.show">
                    <v-icon>{{ item.show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-slide-y-transition>
                  <v-card-text v-show="item.show">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 v-if="item.transactionType !== 'transfer'">Account: {{ item.account }}</v-flex>
                      <v-flex xs12 sm6 v-if="item.transactionType === 'transfer'">Transfer From Account: {{ item.transferFrom }}</v-flex>
                      <v-flex xs12 sm6 v-if="item.transactionType === 'transfer'">Transfer To Account: {{ item.transferTo }}</v-flex>
                      <v-flex xs12 sm6>Transaction Date: {{ item.transactionDate }}</v-flex>
                      <v-flex xs12 sm6>Transaction Time: {{ item.transactionTime }}</v-flex>
                      <v-flex xs12 sm6>Transaction Type: {{ item.transactionType }}</v-flex>
                      <v-flex xs12 sm6>Transaction Amount: {{ item.transactionAmount }}</v-flex>
                      <v-flex xs12 sm6 v-if="item.budget !== 'None' && item.budget !== ''">Budget: {{ item.budget }}</v-flex>
                      <v-flex xs12 sm6>Category: {{ item.category }}</v-flex>
                      <v-flex xs12>Comment: {{ item.comment }}</v-flex>
                      <v-divider v-if="item.recurringTransaction"></v-divider>
                      <v-flex xs12 v-if="item.recurringTransaction">Recurring</v-flex>
                      <br />
                      <v-flex xs12 v-if="item.recurringTransaction">Repeats Every {{item.repeat}} {{item.cycle}}</v-flex>

                    </v-layout>
                  </v-card-text>
                </v-slide-y-transition>
              </v-card>
            </v-flex>
          </template>-->

        </v-layout>
      </v-container>

      <!--End Of Card Design-->

     
    </v-container>

    <!-- Delete Account Dialog Box -->
    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Delete</v-card-title>
          <v-card-text>Are you sure you want to delete this Transaction?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="deleteDialog = false">Disagree</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="DeleteTransactionAccept($v.deleteTransaction)">Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End Of Delete Account Dialog Box -->

  </div>
</template>


<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'

  import listItem from '../reuseable/viewListItem/listItem.vue'
  import MyFilter from '../reuseable/filter/Filter.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'ListItem': listItem,
      'MyFilter': MyFilter,
    },
    props: ['drawer'],
    data() {
      return {
        direction: 'left',
        speedDial: false,
        transition: 'slide-y-reverse-transition',
        moreOptions: false,
        search: '',
        viewSearch: false,
        viewFilter: false,
        filterBy: {
          transactionType: 'None',
          budget: 'None',
          category: 'None',
          currency: 'None',
          paymentType: 'None',
          show: false
        },
        addItem: false,
        datemenu: false,
        timemenuvisibilty: false,
        transactionItemsSearch:'',
        currency: ["JMD", "USD"],
        account: ["All Accounts"],
        transferAccount: [],
        selectedAccount: 'All Accounts',
        category: ["cat1", "cat2", "cat3", "cat4"],
        budget: [],
        period: ["All", "Day", "Week", "Month", "Year", "Custom"],
        paymentType: ["Cash", "Credit Card", "Debit Card", "Bank Transfer", "Voucher"],
        selectedPeriod: 'All',
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        //transactionItemTemp: {
        //  itemName: '',

        //},
        currentTransaction: {
          id: 0,
          account: '',
          transactionName: '',
          transactionType: 'expense',
          transactionAmount: 0,
          paymentType: '',
          comment: '',
          category: '',
          currency: '',
          items: [
            {
              item: "item1",
              price: 12
            },
            {
              item: "item2",
              price: 12
            }],

          transactionDate: '',
          transactionTime: null,

          transferFrom: '',
          transferTo: '',

          recurringTransaction: false,

          //Recurring Transactions
          repeat: 1,
          cycle: '',
          period: 'Forever',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: 'New',
          show: false
        },
        deleteTransaction: {
          id: 0,
          transactionName: '',
          account: '',
          transactionType: '',
          transactionAmount: 0,
          paymentType: '',
          comment: '',
          category: '',
          currency: '',
          items: [],

          transactionDate: '',
          transactionTime: null,

          transferFrom: '',
          transferTo: '',

          recurringTransaction: false,

          //Recurring Transactions
          repeat: 1,
          cycle: '',
          period: 'Forever',
          numberOfCycles: 1,
          goesOffFirst: '',

          //State of Current Object
          objectState: '',
          show: false
        },
        transactionType: 1,
        items: [],
        itemsMinusDeleted: []
      }
    },
    computed: {
      accountErrors() {
        const errors = []
        if (!this.$v.currentTransaction.account.$dirty && !this.$v.editTransaction.account.$dirty) return errors
        !this.$v.currentTransaction.account.required && !this.$v.editTransaction.account.required && errors.push('Account is required')
        return errors
      },
      transferFromErrors() {
        const errors = []
        if (!this.$v.currentTransaction.transferFrom.$dirty && !this.$v.editTransaction.transferFrom.$dirty) return errors
        !this.$v.currentTransaction.transferFrom.required && !this.$v.editTransaction.transferFrom.required && errors.push('Tranfer from is required')
        return errors
      },
      transferToErrors() {
        const errors = []
        if (!this.$v.currentTransaction.transferTo.$dirty && !this.$v.editTransaction.transferTo.$dirty) return errors
        !this.$v.currentTransaction.transferTo.required && !this.$v.editTransaction.transferTo.required && errors.push('Tranfer to is required')
        if (this.currentTransaction.transferTo === this.currentTransaction.transferFrom) errors.push('Cannot tranfer to the same Account')
        return errors
      }, 
      paymentTypeErrors() {
        const errors = []
        if (!this.$v.currentTransaction.paymentType.$dirty && !this.$v.editTransaction.paymentType.$dirty) return errors
        !this.$v.currentTransaction.paymentType.required && !this.$v.editTransaction.paymentType.required && errors.push('Payment Type is required')
        return errors
      },
      categoryErrors() {
        const errors = []
        if (!this.$v.currentTransaction.category.$dirty && !this.$v.editTransaction.category.$dirty) return errors
        !this.$v.currentTransaction.category.required && !this.$v.editTransaction.category.required && errors.push('Category is required')
        return errors
      },
      transactionAmountErrors() {
        const errors = []
        if (!this.$v.currentTransaction.transactionAmount.$dirty && !this.$v.editTransaction.transactionAmount.$dirty) return errors
        !this.$v.currentTransaction.transactionAmount.minValue && !this.$v.editTransaction.transactionAmount.minValue && errors.push('Transaction Amount must be at least 1')
        return errors
      },
      currencyErrors() {
        const errors = []
        if (!this.$v.currentTransaction.currency.$dirty && !this.$v.editTransaction.currency.$dirty) return errors
        !this.$v.currentTransaction.currency.required && !this.$v.editTransaction.currency.required && errors.push('Category is required')
        return errors
      },
      //transactionItemNameErrors() {
      //  const errors = []
      //  if (!this.$v.transactionItemTemp.itemName.$dirty ) return errors
      //  !this.$v.transactionItemTemp.itemName.required && errors.push('Item Name is required')
      //  return errors
      //}
    },
    methods: {
      launchAddTransactionAndPopulateDateTime: function() {
        this.addDialog = true
        let date = new Date()

        let month = date.getMonth() + 1
        if (month < 10) {
          month = "0" + month
        }

        let day = date.getDate()
        if (day < 10) {
          day = "0" + day
        }

        this.currentTransaction.transactionDate = date.getFullYear() + "-" + month + "-" + day

        this.currentTransaction.transactionTime = date.getHours() + ":" + date.getMinutes()

      },
      TransactionCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if ($v.account.$invalid || $v.category.$invalid || $v.transactionAmount.$invalid || $v.currency.$invalid || $v.paymentType.$invalid) {
          return false
        }
        return true
      },
      AddTransactionCheck: function ($v) {
        if (this.TransactionCheck($v)) {
          this.AddTransaction();
        }
      },
      AddTransaction: function () {
        if (this.currentTransaction.transactionAmount < 0 || !(/^[0-9]+$/.test(this.currentTransaction.transactionAmount)) || this.currentTransaction.transactionAmount === "") { this.currentTransaction.transactionAmount = 0 }

        let newEntry = JSON.parse(JSON.stringify(this.currentTransaction))

        this.addDialog = false

        newEntry.id = this.getLargestIdFromItems() + 1

        this.$store.commit('addNewTransactionToStore', newEntry)
        this.resetCurrentTransactionObject()
      },
      getLargestIdFromItems: function () {
        let largest = 0
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id > largest) {
            largest = this.items[i].id
          }
        }
        return largest
      },
      UpdateEditedTransaction: function ($v) {
        if (this.TransactionCheck($v)) {
          this.editDialog = false

          this.editTransaction.objectState = "Update"

          this.$store.commit('updateTransactioninStore', this.editTransaction)
        }
      },
      EditTransaction: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i] === item) {
            let editEntry = JSON.parse(JSON.stringify(this.items[i]))
            this.editTransaction = editEntry
            break
          }
        }

        this.editDialog = true
      },
      DeleteTransactionAccept: function () {
        this.deleteDialog = false

        this.deleteTransaction.objectState = "Delete"

        this.$store.commit('markTransactionAsDeleted', this.deleteTransaction)
      },
      DeleteTransaction: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === item) {
            this.deleteTransaction = this.items[i]
            break
          }
        }

        this.deleteDialog = true
      },
      resetCurrentTransactionObject: function () {
        this.currentTransaction.transactionType = "expense"
        this.currentTransaction.transactionAmount = 0
        this.currentTransaction.paymentType = ""
        this.currentTransaction.comment = ""
        this.currentTransaction.category = ""
        this.currentTransaction.currency = ""
        this.currentTransaction.transactionDate = ""
        this.currentTransaction.transactionTime = null
      },
      removeDeletedTransactionsFromItems: function () {
        this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items))

        for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].objectState === 'Delete') {
            this.itemsMinusDeleted.splice(i, 1)
          }
        }
        
      },
      redirectToEditPage: function (item) {
        this.$router.push({ path: '/dashboard/edittransaction/' + item })
      },
      getSearchItems: function () {
        //Check if Search is empty
        if (this.search === '') {
          return
        }

        //Get All Items from item
        this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items))

        //Remove Transactions that does not meet search criteria 
        for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].transactionName.indexOf(this.search) === -1) {
            this.itemsMinusDeleted.splice(i, 1);
          }
        }

      },
      getitemsFromStoreAndRemoveDeletedItems: function () {
        this.items = JSON.parse(JSON.stringify(this.$store.state.Transactions))

        ///Remove deleted items from items array
        this.removeDeletedTransactionsFromItems()
      },
      getfilteredData: function (filter) {
        this.filterBy.transactionType = filter.transactionType
        this.filterBy.budget = filter.budget
        this.filterBy.category = filter.category
        this.filterBy.currency = filter.currency
        this.filterBy.paymentType = filter.paymentType
        this.viewFilter = filter.show

        this.filterdata()
      },
      filterdata: function () {
        this.getitemsFromStoreAndRemoveDeletedItems()

        //Filter By TransactionType
        if (this.filterBy.transactionType !== 'None') {
          for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
            if (this.itemsMinusDeleted[i].transactionType.toLowerCase() !== this.filterBy.transactionType.toLowerCase()) {
              this.itemsMinusDeleted.splice(i, 1);
            }
          }
        }

        //Filter By Budget
        if (this.filterBy.budget !== 'None') {
          for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
            if (this.itemsMinusDeleted[i].budget.toLowerCase() !== this.filterBy.budget.toLowerCase()) {
              this.itemsMinusDeleted.splice(i, 1);
            }
          }
        }

        //Filter By Category
        if (this.filterBy.category !== 'None') {
          for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
            if (this.itemsMinusDeleted[i].category.toLowerCase() !== this.filterBy.category.toLowerCase()) {
              this.itemsMinusDeleted.splice(i, 1);
            }
          }
        }

        //Filter By Currency
        if (this.filterBy.currency !== 'None') {
          for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
            if (this.itemsMinusDeleted[i].currency.toLowerCase() !== this.filterBy.currency.toLowerCase()) {
              this.itemsMinusDeleted.splice(i, 1);
            }
          }
        }

        //Filter By PaymentType
        if (this.filterBy.paymentType !== 'None') {
          for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
            if (this.itemsMinusDeleted[i].paymentType.toLowerCase() !== this.filterBy.paymentType.toLowerCase()) {
              this.itemsMinusDeleted.splice(i, 1);
            }
          }
        }

      }
    },
    beforeMount() {
    this.getitemsFromStoreAndRemoveDeletedItems()

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let cur = this.$store.state.Currencies
      for (let i = 0; i < cur.length; i++) {
        this.currency.push(cur[i].currencyName)
      }

      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
        this.transferAccount.push(acc[i].accountName)
      }
      
    },
    validations: {
      currentTransaction: {
        account: {
          required
        },
        category: {
          required
        },
        transactionAmount: {
          required,
          minValue: minValue(1)
        },
        transactionDate: {
          required
        },
        transactionTime: {
          required
        },
        paymentType: {
          required
        },
        currency: {
          required
        },
        transferFrom: {
          required
        },
        transferTo: {
          required
        }
      },
      editTransaction: {
        account: {
          required
        },
        category: {
          required
        },
        transactionAmount: {
          required,
          minValue: minValue(1)
        },
        transactionDate: {
          required
        },
        transactionTime: {
          required
        },
        paymentType: {
          required
        },
        currency: {
          required
        },
        transferFrom: {
          required
        },
        transferTo: {
          required
        }
      },
      //transactionItemTemp: {
      //  itemName: {
      //    required
      //  }

      //}
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/transaction/ViewTransactions.vue